export default __webpack_public_path__ + "static/media/02.fd84dba6.png";